import { getCompleteSizes, TAdFoxBannerSizeProps } from '@cian/adfox-component';
import { makeContextModule } from '@cian/react-utils';
import React, { FC, JSX, useMemo } from 'react';

import { useAdfoxParameters } from './internal/hooks/useAdfoxParameters';
import { PParams } from './types';
import { AdfoxContextData } from '../../types/adfox/AdfoxContextData';

const contextData = makeContextModule<AdfoxContextData>({ contextName: 'AdfoxContextData' });

const {
  Context: { Provider },
} = contextData;

export const { useContext: useAdfoxContext, withContext: withAdfoxContext } = contextData;

export type AdfoxContextProviderProps = Omit<AdfoxContextData, 'params' | 'sizes'> & {
  children: JSX.Element | JSX.Element[];
  pParams: PParams;
  size: TAdFoxBannerSizeProps;
};

export const AdfoxContextProvider: FC<AdfoxContextProviderProps> = props => {
  const { children, pParams, size, postViewAnalyticsData } = props;

  const params = useAdfoxParameters(pParams);

  const contextValue = useMemo(
    (): AdfoxContextData => ({ params, sizes: getCompleteSizes(size), postViewAnalyticsData }),
    [params, postViewAnalyticsData, size],
  );

  const key = useMemo(() => JSON.stringify(params, null, 0), [params]);

  return (
    <Provider
      // При изменении параметров, даже если выдача не меняется, Adfox должен перезагружаться
      key={key}
      value={contextValue}
    >
      {children}
    </Provider>
  );
};
